var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedirect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.114,
    height: 32.165,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 50h50V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 -17.276 49.416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.674 33.647h1.674v1.695h-1.674zm6.879-.002h1.694v1.68h-1.694zm-3.435.006h1.672v1.693h-1.672zm-5.161 2.256c.069.101.139.201.207.302.339.505.77.826 1.42.826 4.519.002 9.037.018 13.557.026 1.567.003 3.135-.005 4.702-.008.842-.001 1.612-.753 1.615-1.6.009-3.389.012-6.778.017-10.168 0-.067-.006-.135-.01-.226h-1.716v6.825H14.684V18.14h2.539v-1.71c-.592 0-1.186-.002-1.779.001-.243.001-.486.036-.726.021-.81-.048-1.32.369-1.668 1.049-.026.05-.061.094-.093.142z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.322.068-.649.12-.967.208-1.898.525-3.247 2.336-3.163 4.236.091 2.044 1.492 3.722 3.453 4.112.315.062.642.077.963.079 1.163.004 2.326-.007 3.49-.013 1.353-.007 2.406-.627 3.237-1.643.608-.742.88-1.625.926-2.606H5.363c-.074.559-.286 1.055-.768 1.364-.223.143-.504.266-.762.271-1.334.03-2.669.03-4.003.014-.604-.007-1.299-.794-1.349-1.468-.079-1.068.511-1.767 1.701-1.962 0-.273.004-.556-.001-.839C.169 1.168.152.584.139 0Z",
    style: {
      fill: "#00c0ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(23.957 12.938)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2.563c.016-.056.039-.117.052-.181.229-1.04.822-1.516 1.892-1.516 1.118 0 2.238.031 3.354-.011.658-.025 1.475.669 1.59 1.343.174 1.016-.386 1.846-1.407 2.064-.079.017-.156.041-.272.072v2.537A4.14 4.14 0 0 0 9.7 3.845c1.64-.833 2.545-2.52 2.34-4.335a4.294 4.294 0 0 0-3.231-3.681 3.495 3.495 0 0 0-.823-.089 208.447 208.447 0 0 0-3.874-.001C2.172-4.239.369-2.645.09-.721.058-.494.033-.267 0 0",
    style: {
      fill: "#00c0ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(24.974 17.275)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.359-3.043v2.012h-4.739V.997h4.713v2.066L0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(27.765 26.297)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirect);
export default __webpack_public_path__ + "static/media/redirect.34ecac30eb4c67a895e0fe0abe3ea4d6.svg";
export { ForwardRef as ReactComponent };